<template>
  <div class="header-main">
    <div class="header-main__ctrl">
      <div class="header-main__ctrl__left">
        <a 
          href="/"
          class="header-main__ctrl__left__home">
            <img src="../../assets/ds-logo.png" class="header-main__ctrl__left__home__logo">
        </a>
      </div>
      <slot name="rightMov">
        <!-- aqui va contenido slot para la derecha en movil -->
      </slot>
    </div>

    <div v-if="dataHome">
      <v-congrans-text 
        v-if="dataHome.show_congrans"
        :text="dataHome.text_congrans"
        :color="dataHome.color_congrans"
        :bg="dataHome.bg_congrans"
      />
    </div>
    
    <div 
      class="header-main__search">
      <form 
        class="header-main__search__left"
        method="GET"
        @submit.prevent="buscarResultados()">
          <router-link 
            :to="{name: 'home'}"
            class="header-main__search__left__title">
            Deporstar
          </router-link>
          <div class="header-main__search__left__form">
            <input 
              type="text"
              class="header-main__search__left__txt"
              placeholder="Buscar Torneo"
              v-model="kword"
              @click="kwordActive=true">
            
            <div v-if="showResults" class="form-results">
              <a @click="closeResults()" class="form-results__close">Cerrar</a>
              <ul class="form-results__list">
                <li 
                  v-for="torneo in listaResultados"
                  :key="torneo.id"
                  @click="this.kwordActive = false"
                  class="form-results__list__item">
                    <router-link
                      :to="{ name: detailTorneoPath, params: {'idTorneo':  torneo.id }}"
                      class="form-results__list__item__link">
                        <span style="font-weight: bold;">{{ torneo.name }}</span> - {{ torneo.competition.name }}
                    </router-link>
                </li>
              </ul>
            </div>
          </div>
      </form>
      <div class="header-main__search__right">
        <slot name="rightPc">
          <!-- aqui va contenido slot para dimesiones pc -->
        </slot>
      </div>
    </div>
    <div v-if="dataHome">
      <div v-if="dataHome.showealert" class="header-alert" :style="{'background': dataHome.bg_msj}">
        <a 
          :href="dataHome.link_alert"
          target="_blank"
          :style="{'color': dataHome.color_msj}"
          class="header-alert__text">
            {{ dataHome.message_alert }}
        </a>
        <a href="#" class="header-alert__close" @click="dataHome.showealert = false">Cerrar</a>
      </div>
    </div>
  </div>
</template>

<script>

  import { torneoSearch } from '@/api/Torneo'
  import _ from 'lodash'
  //
  import { mapActions, mapGetters } from 'vuex'
  //
  import VButtonMain from '@/components/base/VButtonMain.vue'
  import VCongransText from '@/components/base/VCongransText.vue'

  export default {
    name: 'HeaderBase',
    components: {
      VButtonMain,
      VCongransText
    },
    data() {
      return {
        kword: '',
        listaResultados: [],
        kwordActive: false
      }
    },
    computed: {
      ...mapGetters({
        isLoggedIn: 'isLoggedIn',
        dataHome: 'dataHome',
      }),
      detailTorneoPath: function () {
        if (this.isLoggedIn) {
          return 'torneo-user-info'
        } else { return 'home-detalle-torneo' }
      },
      showResults: function () {
        if ((this.listaResultados.length > 0) && (this.kwordActive)) {
          return true
        } else {
          return false
        }
      }
    },
    methods: {
      ...mapActions({
        cargarHome: 'cargarHome',
      }),
      debouceSearchTorneo: _.debounce(function (val) {
        this.searchResultados(val)
      }, 300),
      searchResultados: function (kword) {
        torneoSearch(kword).then(
          (response) => {
            this.listaResultados = response.data.results
          }
        ).catch(
          (error) => {
            console.log(error)
            this.listaResultados = []
          }
        )
      },
      buscarResultados: function () {
        this.kwordActive = false
        if (this.isLoggedIn) {
          this.$router.push({name: 'panel-resultados-busqueda', query: { kword: this.kword }})
        } else {
          this.$router.push({name: 'home-resultados-busqueda', query: { kword: this.kword }})
        }
      },
      closeResults: function () {
        this.kwordActive = false
      }
    },
    watch: {
      kword: function (val) {
        this.kwordActive = true
        this.debouceSearchTorneo(val)
      }
    },
    beforeMount() {
      this.kword = this.$route.query.kword
      this.kwordActive = false
    }
  }
</script>

<style lang="scss" scoped>
  .header-main {
    &__ctrl {
      background: $color-3;
      text-align: center;
      padding: 10px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      @include desde($large) {
        display: none;
      }
      &__left {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        &__menu {
          text-decoration: none;
          margin-right: 15px;
          @include hasta($medium) {
            margin-right: 5px;
          }
        }
        &__home {
          display: none;
          &__logo {
            width: 30px;
            height: 30px;
            border-radius: 50%;
          }
        }
      }
      &__right {
        text-decoration: none;
      }
    }
    &__search {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      @include desde($large) {
        background: $color-3;
        padding: 10px;
      }
      &__left {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        @include desde($large) {
          width: 50%;
        }
        &__form {
          display: block;
          width: 100%;
          padding: 3px;
          position: relative;
        }
        &__txt {
          display: block;
          width: 100%;
          padding-left: 5px;
          padding-right: 5px;
          border-radius: 10px;
          height: 30px;
          font-size: 14px;
          font-family: $ff-2;
          border: 2px solid $color-8;
          &:active {
            outline: none;
            border: 2px solid $color-6;
          }
          &:focus {
            outline: none;
            border: 2px solid $color-6;
          }
          @include desde($large) {
            margin: 5px;
            width: 100%;
            padding-left: 10px;
            padding-right: 10px;
            border-radius: 15px;
            height: 40px;
            font-size: 15px;
          }
        }
        &__title {
          display: none;
          @include desde($large) {
            display: block;
            background: $color-3;
            padding: 10px;
            text-decoration: none;
            font-size: 30px;
            font-family: $ff-1;
            font-weight: bold;
            color: $color-white;
            margin-right: 1em;
          }
        }
      }
      &__right {
        display: none;
        @include desde($large) {
          width: 50%;
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }
      }
    }
  }

  .form-results {
    display: block;
    width: 100%;
    position: absolute;
    top: 35px;
    left: 0px;
    z-index: 100;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 3px;
    @include desde($large) {
      top: 50px;
    }
    &__close {
      position: absolute;
      z-index: 101;
      background: $color-2;
      color: white;
      font-family: $ff-3;
      font-size: 14px;
      padding: 2px 10px;
      border-radius: 10px;
      top: 5px;
      right: 20px;
      &:hover {
        cursor: pointer;
      }
    }
    &__list {
      list-style: none;
      border-radius: 10px;
      border: $color-8 1px solid;
      margin: 0px;
      padding: 0px;
      background: $color-white;
      width: 100%;
      max-height: 300px;
      overflow-y: auto;
      &__item {
        display: block;
        &__link {
          display: block;
          padding: 10px;
          text-decoration: none;
          font-family: $ff-2;
          color: $color-1;
          width: 100%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          &:hover {
            background: $color-8;
          }
        }
      }
    }
  }
  .header-alert {
    position: relative;
    background: $color-2;
    padding: 5px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    &__text {
      display: block;
      color: $color-white;
      text-decoration: none;
      font-family: $ff-1;
      width: 80%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: center;
      font-size: 14px;
      &:hover {
        cursor: pointer;
        opacity: 0.7;
      }
    }
    &__close {
      position: absolute;
      right: 1em;
      color: $color-8;
      padding: 2px 10px;
      font-family: $ff-4;
      background: $color-2;
      font-size: 13px;
      border-radius: 3px;
    }
  }
</style>